var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"page"}},[_c('div',{staticClass:"lefttext"},[_vm._v("选择开卡区域")]),_vm._v(" "),_c('div',{staticClass:"wrapper"},_vm._l((_vm.areas),function(item,index){return _c('div',{key:index,staticClass:"wrapper-content",on:{"click":function($event){return _vm.itemClick(item)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n    ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce1719be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApplyCard.vue
// module id = null
// module chunks = 